module.exports = __webpack_public_path__ + "static/images/gifts.b5c5cfa.png";